import { reelStripsForMode, TFf037Config, TFf037Mode } from './helpers';

/** Find a real full-screen paying-symbol result, using the configured Ways or Lines count. */
export const findFf037BigWin = (config: TFf037Config, mode: TFf037Mode) => {
  const bet = config.betMultiplier;
  const levels = config.winLevels ?? Object.entries(config.limits ?? {}).map(([name, threshold]) => ({ name, threshold }));
  const bigWinIndex = levels.findIndex(level => level.name === 'bigWin');
  if (!bet || !Number.isFinite(bet) || bet <= 0 || bigWinIndex <= 0) return undefined;
  const minimum = levels[bigWinIndex - 1].threshold;
  const strips = reelStripsForMode(config, mode);
  if (!strips.length || strips.length !== config.reelsSetup.length ||
    config.reelsSetup.some(rows => !Number.isInteger(rows) || rows < 1)) return undefined;
  const combinations = config.lines?.length ?? config.reelsSetup.reduce((total, rows) => total * rows, 1);
  let best: { reelIndexes: number[]; symbol: string; multiplier: number; winLevel: string } | undefined;
  for (const [symbol, payouts] of Object.entries(config.paytable ?? {})) {
    const payout = payouts[0];
    if (!Number.isFinite(payout) || payout <= 0 || symbol === config.coinFeature.coin) continue;
    const reelIndexes = strips.map((strip, reel) => strip.findIndex((_symbol, stop) =>
      Array.from({ length: config.reelsSetup[reel] }, (_, row) => strip[(stop + row) % strip.length])
        .every(visible => visible === symbol)));
    if (reelIndexes.some(stop => stop < 0)) continue;
    const multiplier = Math.min(payout * combinations / bet, config.maxWinInCreditsMultiplier ?? Infinity);
    if (multiplier < minimum || (best && multiplier <= best.multiplier)) continue;
    // winLevels are exclusive upper bounds: 50x enters Big Win; 150x enters Luxurious Win.
    const winLevel = levels.find(level => multiplier < level.threshold)?.name ?? levels[levels.length - 1].name;
    best = { reelIndexes, symbol, multiplier, winLevel };
  }
  return best;
};
